import styled from '@emotion/styled';
import { spacing } from '../../../themes';

export const ListWrapper = styled.div`
  padding: ${spacing.tiny} 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
